<template>
  <v-container class="flex-column">
    <div
      v-if="! hasError"
      class="tab-client-bank"
    >
      <v-col
        cols="12"
        class="py-0"
      >
        <v-select
          v-model="bank"
          :items="parsedBanks"
          label="Банк"
          prepend-icon="mdi-warehouse"
          item-text="name"
          item-value="alias"
          @change="changeBank"
        />

        <v-btn
          v-if="getTypeModal !== null"
          class="display-1"
          color="primary"
          dark
          @click="showAddSettingsModal()"
        >
          Добавить
        </v-btn>

        <add-privat-bank-setting-modal
          v-if="getTypeModal === 'privat' && isShowAddSettingsModal"
          :form="getPrivatBankFormState"
          :is-show-modal="isShowAddSettingsModal"
          @closeModal="closeModal()"
          @save="saveSetting"
        />

        <privat-bank-setting-table
          v-if="getTypeModal === 'privat'"
          :has-company-bank-account-settings="hasCompanyBankAccountSettings"
          :is-loading="isLoading"
          :settings="getCompanyPrivatBankAccountSettings"
          @delete="deleteSetting"
        />

        <add-aval-bank-setting-modal
          v-if="getTypeModal === 'aval' && isShowAddSettingsModal "
          :form="getAvalBankFormState"
          :is-show-modal="isShowAddSettingsModal"
          @closeModal="closeModal()"
          @save="saveSetting"
        />
        <aval-bank-setting-table
          v-if="getTypeModal === 'aval'"
          :settings="getCompanyAvalBankAccountSettings"
          :has-company-bank-account-settings="hasCompanyBankAccountSettings"
          :is-loading="isLoading"
          @delete="deleteSetting"
        />
      </v-col>
    </div>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import AddAvalBankSettingModal from '../modal/AddAvalBankSettingModal'
  import AddPrivatBankSettingModal from '../modal/AddPrivatBankSettingModal'
  import AvalBankSettingTable from '../table/AvalBankSettingTable'
  import PrivatBankSettingTable from '../table/PrivatBankSettingTable'

  export default {
    name: 'ClientBank',
    components: { AddPrivatBankSettingModal, AddAvalBankSettingModal, AvalBankSettingTable, PrivatBankSettingTable },
    props: {
      data: {
        type: Object,
      },
    },

    data () {
      return {
        bank: null,
        typeModal: null,
        isShowAddSettingsModal: false,
        settingsBankAccount: [],
      }
    },

    computed: {
      ...mapGetters('banks', ['parsedBanks', 'isLoading', 'hasError', 'error', 'hasBanks']),
      ...mapGetters('companyBankAccountSettings', [
        'companyBankAccountSettings',
        'isLoading',
        'hasError',
        'error',
        'hasCompanyBankAccountSettings',
        'getPrivatBankFormState',
        'getAvalBankFormState',
        'getCompanyPrivatBankAccountSettings',
        'getCompanyAvalBankAccountSettings',
      ]),
      getTypeModal () {
        return this.typeModal
      },
    },

    created () {
      this.$store.dispatch('banks/findAllBanks')
      this.$store.dispatch('companyBankAccountSettings/fetchSettingsAccountsByCompanyOkpo', this.data)
    },

    methods: {
      changeBank (bankAlias) {
        this.typeModal = bankAlias
      },

      showAddSettingsModal () {
        this.isShowAddSettingsModal = true
      },

      closeModal () {
        this.isShowAddSettingsModal = false
      },

      saveSetting: function (formData) {
        formData.company = Object.assign({}, this.data)
        formData.bank_alias === 'privat'
          ? this.$store.dispatch('companyBankAccountSettings/createPrivatBankAccountSetting', formData)
          : this.$store.dispatch('companyBankAccountSettings/createAvalBankAccountSetting', formData)
      },

      deleteSetting: function (setting) {
        setting.company = Object.assign({}, this.data)
        this.$store.dispatch('companyBankAccountSettings/deleteBankAccountSetting', setting)
      },
    },
  }
</script>

<style lang="scss"></style>
